import React, { createContext, useContext, useState, useCallback } from 'react';
import ko from './ko';
import ja from './ja';

const translations = { ko, ja };

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('ko');

  const t = translations[lang] || ko;

  // 통화 포매터 (₩ → ¥ 변환 포함)
  const fmtCurrency = useCallback((value) => {
    if (value == null) return '-';
    const converted = lang === 'ja' ? Math.round(Number(value) * t.currencyRate) : Number(value);
    return `${t.currency}${converted.toLocaleString()}`;
  }, [lang, t]);

  // 숫자 포매터
  const fmtNum = useCallback((value) => {
    if (value == null) return '-';
    return Number(value).toLocaleString();
  }, []);

  // 언어 전환
  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'ko' ? 'ja' : 'ko');
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t, fmtCurrency, fmtNum }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
};

export default LangContext;
